import { MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { IUser } from 'src/app/models/user';
import { StorageService } from 'src/app/services/storage.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StreamingService } from 'src/app/services/streaming.service';

@Component({
  selector: 'app-popup-bids',
  templateUrl: './popup-bids.component.html',
  styleUrls: ['./popup-bids.component.scss'],
})
export class PopupBidsComponent implements OnInit {
  constructor(
    private storageService: StorageService,
    private router: Router,
    private dialogRef: MatDialogRef<PopupBidsComponent>,
    private streaming: StreamingService,
    private _snackBar: MatSnackBar
  ) {}

  loading = true;
  bid_auction_loading = true;

  is_login = false;
  auctions: any = [];
  user: IUser = {} as IUser;

  transactions: any = null;

  ngOnInit(): void {
    if (this.storageService.token) {
      this.is_login = true;
    }

    this.user = this.storageService.myself;
    this.transactions = Object.assign({}, this.streaming.auctions.length > 0 ? this.streaming.auctions[0] : {})

    if (this.transactions.id) {
      // this.openedScheldule()
      this.openedSchelduleRequest()
    } else {
      this.loading = false;
    }

    this.streaming.watchSocket().subscribe({
      next: () => {
        this.transactions = Object.assign({}, this.streaming.auctions.length > 0 ? this.streaming.auctions[0] : {})
        this.openedScheldule()
      },
    });

  }

  openedSchelduleRequest(){
    this.bid_auction_loading = true;


    this.streaming.openedScheldule().subscribe({
      next: (data: any) => {
        this.transactions = data[0];
        this.loading = false;
        this.bid_auction_loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  openedScheldule(){
    this.bid_auction_loading = true;

    // this.streaming.openedScheldule().subscribe({
    //   next: (data: any) => {
        this.transactions = Object.assign({}, this.streaming.auctions.length > 0 ? this.streaming.auctions[0] : {})

        // this.transactions = data[0];
        this.loading = false;
        this.bid_auction_loading = false;
    //   },
    //   error: () => {
    //     this.loading = false;
    //   }
    // });
  }

  goToRealTime(id: string) {
    this.chance('no');

    this.router.navigate(['/streaming'], {
      queryParams: {
        transactions: id,
      },
    });
  }

  eventSocket(event: any) {
    if (event) {
      this.chance('yes');
    } else {
      this.chance('no');
    }
  }

  chance(chance: 'yes' | 'no' | 'login', results?: any): void {
    this.dialogRef.close({ action: chance, results });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
      panelClass: ['edit-snackbar'],
    });
  }
}
